
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class FireEmbersEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (0.5 + layerIndex) * 100 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const scrollY = (time * speed) % spacing;
            const sway = Math.sin(time * 2 + x) * 20;
            
            for (let y = y1; y <= y2; y += spacing / 2) {
                const size = (2 + driftP * 4) * scale;
                const life = (Math.sin(time + x + y) + 1) * 0.5;
                
                const draw = () => {
                    ctx.save();
                    ctx.globalAlpha *= life;
                    ctx.beginPath();
                    ctx.arc(x + sway, y - scrollY, size, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
